import type { AnalyticsEvent, AnalyticsEventPageProperties } from "@octopusdeploy/portal-analytics";
import type { UnknownPageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { Workflow } from "~/workflows/workflows";

interface WorkflowCompletedEvent extends AnalyticsEvent<"Workflow Completed">, Partial<AnalyticsEventPageProperties> {
    WorkflowId: string;
    WorkflowInstanceId: string;
    WorkflowType: "drawer" | "dialog";
    ["Duration (ms)"]: number;
}

interface WorkflowCompletedEventArguments {
    workflow: Workflow<unknown, unknown>;
    workflowInstanceId: string;
    pageRegistration: UnknownPageRegistration | null;
    durationInMs: number;
}

export function createWorkflowCompletedEvent({ workflow, workflowInstanceId, pageRegistration, durationInMs }: WorkflowCompletedEventArguments): WorkflowCompletedEvent {
    const pageFields: AnalyticsEventPageProperties | undefined =
        pageRegistration === null
            ? undefined
            : {
                  "Page Id": pageRegistration.pageId,
                  "Page Area": pageRegistration.pageArea.mainArea,
              };
    return {
        eventName: "Workflow Completed",
        WorkflowId: workflow.workflowId,
        WorkflowType: workflow.workflowType,
        WorkflowInstanceId: workflowInstanceId,
        "Duration (ms)": durationInMs,
        ...pageFields,
    };
}
